import React from "react";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import {Navigate, Outlet, useLocation} from "react-router-dom";

const RequireAuth = () => {

    const { auth } = useAuth();
    const location = useLocation();

    return (
        auth?.login
            ? <Outlet/>
            : <Navigate to={'/auth'} state={{ from: location }} replace={false}/>
    );
}
export default RequireAuth;